import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const OpenSideIcon = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2.5C2.17157 2.5 1.5 3.17157 1.5 4V12C1.5 12.8284 2.17157 13.5 3 13.5H13C13.8284 13.5 14.5 12.8284 14.5 12V4C14.5 3.17157 13.8284 2.5 13 2.5H3ZM2.5 4C2.5 3.72386 2.72386 3.5 3 3.5H13C13.2761 3.5 13.5 3.72386 13.5 4V12C13.5 12.2761 13.2761 12.5 13 12.5H3C2.72386 12.5 2.5 12.2761 2.5 12V4ZM8.5 4C8.22386 4 8 4.22386 8 4.5V11.5C8 11.7761 8.22386 12 8.5 12H12.5C12.7761 12 13 11.7761 13 11.5V4.5C13 4.22386 12.7761 4 12.5 4H8.5Z"
      />
    </IconWrapper>
  );
};

export default OpenSideIcon;
